export default __webpack_public_path__ + "static/115-min-min-1be3a1f0b8268faa4be79791cdd3dc63.jpg";